import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
import { AuthService } from '../../core/auth/auth.service';
import { Location } from '@angular/common';
import { environment } from '../../../environments/environment';
import { WINDOW, LOCAL_STORAGE } from '@ng-toolkit/universal';
import {FonctionUtiles} from "../fonctionsUtiles";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  url: string;
  user: any;
  modePro: boolean;
  logoName: string;
  isPro: boolean = false;
  curentlang :string = "";
  curentLangFlag :string = "";
  token:string;
  backOfficeUrl = environment.backOfficeUrl;

  constructor(@Inject(WINDOW) private window:Window,
    @Inject(LOCAL_STORAGE) private localStorage: any,
    @Inject(PLATFORM_ID) private platformId: Object,
      public authService: AuthService,
      private location: Location,public functionUtils:FonctionUtiles) {
      console.log("const header");
      this.url = (location.path()) ? location.path(): 'home';
      this.modePro = environment.pro;
      this.logoName = (this.modePro) ? 'logo-pro.png' : 'logo.png';
      this.curentlang = functionUtils.retrieve('curentLang') || 'fr';
      this.curentLangFlag = functionUtils.retrieve('curentLangFlag') || 'assets/imgs/france.png';
      if(!this.modePro) {
        this.token = authService.getToken();
      }
  }

  formatedAppUrl(token) {
    return `${this.backOfficeUrl}/handletoken/${token}`;
  }


  getItem(item: string) {
    return item ? item : ''
  }


  ngOnInit() {
     this.user = this.authService.getUser();
  }

  logout() {
    this.authService.logout();
  }

  getUser() {
    return this.authService.getUser();
  }


  loggedIn() {
    return this.authService.hasValidToken();
  }

  useLanguage(language, event) {
    this.curentlang = language;
    this.curentLangFlag = this.functionUtils.languageFlagMap[language.toLowerCase()];
    this.functionUtils.useLanguage(language, event)
  }
}
